// extracted by mini-css-extract-plugin
export default {"main":"style_main__JGvCA","navBar":"style_navBar__EvByg","body":"style_body__WRKte"};